import getInstance from "../config/api";

export default class PreContract {
  static async fetchPreContracts(params) {
    const instance = getInstance();
    const { data } = await instance.get("/simulation", { params });
    return data;
  }
  static async fetchPreContractsConsolidade(params) {
    const instance = getInstance();
    const { data } = await instance.get("/simulation/grouped", { params });
    return data;
  }
  static async downloadPreContracts(params) {
    const instance = getInstance();
    const data = await instance.get("/simulation/csv", { params });
    return data;
  }
  static async downloadPreContractsConsolidated(params) {
    const instance = getInstance();
    const data = await instance.get("/simulation/grouped-csv", { params });
    return data;
  }
}
